import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { type ModalType, closeModal } from '~shared/actions/modal';
import { snakeToProperCase } from '~shared/helpers/string';
import { useAnalytics } from '~shared/hooks/useAnalytics';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import getIsModalShowing from '~shared/selectors/modal/getIsModalShowing';
import getModalProps from '~shared/selectors/modal/getModalProps';
import getModalType from '~shared/selectors/modal/getModalType';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import GetTheAppDrawer from './GetTheAppDrawerContainer';
import { PostDeliveryModal } from '~web/features/post-delivery/components/PostDeliveryModal';
import { PhiAuthModal } from '~web/features/profile/components/PhiAuthModal';

type Props = {
  readonly showing: boolean;
  readonly type: ModalType;
  readonly closeModal: (modalType: ModalType) => void;
  readonly props: Record<string, unknown> | null | undefined;
};

const AppModals = ({ closeModal, props, showing, type }: Props) => {
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    if (showing && type) {
      trackEvent({
        event: EVENTS.MODAL_VIEWED,
        params: {
          origin: window.location.pathname,
          type: snakeToProperCase(type),
        },
      });
    }
  }, [trackEvent, type, showing]);

  const close = () => {
    closeModal(type);
  };

  if (!showing) {
    return null;
  }

  switch (type) {
    case 'POST_DELIVERY_MODAL':
      return (
        <PostDeliveryModal
          onClose={close}
          {...props}
        />
      );

    case 'PHI_AUTH_MODAL':
      return (
        <PhiAuthModal
          onClose={close}
          {...props}
        />
      );

    case 'GET_THE_APP_DRAWER':
      return (
        <GetTheAppDrawer
          onClose={close}
          {...props}
        />
      );

    default:
      return null;
  }
};

const mapStateToProps = (state: ReduxStateShared) => {
  return {
    showing: getIsModalShowing(state),
    type: getModalType(state),
    props: getModalProps(state),
  };
};

const mapDispatchToProps = {
  closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppModals));
